import { createMuiTheme } from '@material-ui/core/styles';
import { DEFAULT_THEME } from "../../../themes/defaultTheme";
import { buildThemeOptions } from "./buildThemeOptions";
import { _createOldMichelinTheme } from "./_createOldMichelinTheme";
export var createBaseTheme = function createBaseTheme(options) {
  var _options$palette, _palette$type;

  var palette = (_options$palette = options == null ? void 0 : options.palette) != null ? _options$palette : {};
  var acidThemeType = (_palette$type = palette.type) != null ? _palette$type : DEFAULT_THEME;

  if (acidThemeType === 'michelin') {
    return _createOldMichelinTheme(options);
  }

  var muiThemeOptions = buildThemeOptions(options);
  var baseTheme = createMuiTheme(muiThemeOptions);
  return baseTheme;
};